import API from '../../API.js';
const chalk = require("chalk");
import {table} from 'table';

exports.command = 'rollback <siteID> <versionID>'
exports.desc = 'Rollback your site to the provided version.'
exports.builder = function (yargs) {

  const epilog = chalk.dim("Darwin Command Line Interface\nCopyright 2019 Darwin Inc. All Rights Reserved.\n")

  return yargs
    .usage('Usage:\ndarwincli site rollback <siteID> <versionID>')
    .positional('siteID', {
      describe: 'The id of the site to rollback',
      type: 'string'
    })
    .positional('versionID', {
      describe: 'The id of the site version to make active',
      type: 'string'
    })
    .help()
    .epilog(epilog)
}

exports.handler = function (argv) {
  API.clientCallDarwinAPI("PUT", "siteUpload", {
    "siteID": argv.siteID,
    "deploymentID": argv.versionID,
  }, [], (result, data) => {
    if (!result) {
      console.log(chalk.bold.red(data.error || data))
      return
    }
    console.log(chalk.blue.bold("Your site has been rolled back."))
  }, process.env.DARWIN_CLIENT_ID, process.env.DARWIN_CLIENT_SECRET)
}
